<template>
    <div class="trustpilot-widget" data-locale="fr-FR" data-template-id="5406e65db0d04a09e042d5fc" data-businessunit-id="5fce738eaaccf5000185899d" data-style-height="28px" data-style-width="100%" data-theme="light">
        <a href="https://fr.trustpilot.com/review/groupe-agpm.fr" target="_blank" rel="noopener">Trustpilot</a></div>
</template>

<script>
export default {
    created() {
        window.trustbox(document, 'script');
    }
}
</script>

